module.exports = __webpack_public_path__ + "media/country_flags/ao-9b10ab6a.png";